module.exports = __webpack_public_path__ + "img/slide1.f49b0347.png";